// extracted by mini-css-extract-plugin
export default {"back_button_section":"backButton_back_button_section__ziH7x","back_button_right":"backButton_back_button_right__WmQRQ"};